import {
  FilteredCreditApplication,
  Loader,
  useGetAvailableCredit,
  useMerchantFinancingConfig,
} from '@applyonline/shared'
import { EWorksheetStatus } from '@if/core/types'
import { Navigate, useNavigate, useParams } from 'react-router-dom'
import { getWorksheet } from '../../data/creditapp-selectors'
import { DEFAULT_STEP, EWorksheetStep, EWorksheetStepList } from './hooks'
import { canAccessWorksheet } from './selectors'
import WorksheetStepper from './WorksheetStepper'

interface Props {
  creditApp: FilteredCreditApplication
}

const WorksheetPage = ({ creditApp }: Props) => {
  const { step } = useParams<{ step: EWorksheetStep }>()
  const navigate = useNavigate()
  const worksheet = getWorksheet(creditApp)
  const [financingProgramConfig, isFetchingConfig] = useMerchantFinancingConfig(
    creditApp.merchantId,
    creditApp.financingProgramId,
  )
  const [availableCredit, isLoadingAvailableCredit] = useGetAvailableCredit(
    creditApp.id,
    creditApp.financingProgramId,
    true,
  )

  if (!step || !EWorksheetStepList.includes(step)) return <Navigate to={`../worksheet/${DEFAULT_STEP}`} replace />
  if (!canAccessWorksheet(creditApp)) {
    if (creditApp.worksheet?.status !== EWorksheetStatus.Draft)
      return <Navigate to={`/creditapplication/${creditApp.id}/contract`} replace />
    return <Navigate to=".." replace />
  }

  return isFetchingConfig || isLoadingAvailableCredit ? (
    <Loader description="" />
  ) : (
    <WorksheetStepper
      creditApp={creditApp}
      setStep={(s) => navigate(`../worksheet/${s}`, { replace: true })}
      step={step}
      worksheet={worksheet}
      financingProgramConfig={financingProgramConfig!}
      availableCredit={availableCredit}
    />
  )
}

export default WorksheetPage
